__turbopack_context__.v({
  "container": "company-what-we-built-section-module__xFWvWG__container",
  "content": "company-what-we-built-section-module__xFWvWG__content",
  "header": "company-what-we-built-section-module__xFWvWG__header",
  "introLine": "company-what-we-built-section-module__xFWvWG__introLine",
  "leadParagraph": "company-what-we-built-section-module__xFWvWG__leadParagraph",
  "leadStack": "company-what-we-built-section-module__xFWvWG__leadStack",
  "modules": "company-what-we-built-section-module__xFWvWG__modules",
  "section": "company-what-we-built-section-module__xFWvWG__section",
  "valueBadge": "company-what-we-built-section-module__xFWvWG__valueBadge",
  "valueBadgeFill": "company-what-we-built-section-module__xFWvWG__valueBadgeFill",
  "valueIcon": "company-what-we-built-section-module__xFWvWG__valueIcon",
  "valueItem": "company-what-we-built-section-module__xFWvWG__valueItem",
  "valueKlabLogo": "company-what-we-built-section-module__xFWvWG__valueKlabLogo",
  "valueNumber": "company-what-we-built-section-module__xFWvWG__valueNumber",
  "valueText": "company-what-we-built-section-module__xFWvWG__valueText",
  "valuesAnswer": "company-what-we-built-section-module__xFWvWG__valuesAnswer",
  "valuesCard": "company-what-we-built-section-module__xFWvWG__valuesCard",
  "valuesGrid": "company-what-we-built-section-module__xFWvWG__valuesGrid",
  "valuesPills": "company-what-we-built-section-module__xFWvWG__valuesPills",
  "valuesQuestion": "company-what-we-built-section-module__xFWvWG__valuesQuestion",
});
